import { render, staticRenderFns } from "./FileBoxedView.vue?vue&type=template&id=1f9de850&scoped=true"
import script from "./FileBoxedView.vue?vue&type=script&lang=js"
export * from "./FileBoxedView.vue?vue&type=script&lang=js"
import style0 from "./FileBoxedView.vue?vue&type=style&index=0&id=1f9de850&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f9de850",
  null
  
)

export default component.exports